import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuditService {

	constructor(
		private http: HttpClient
	) { }

	async getAuditLogForRecord(id: number = 0, page: number = 1, paging: any = {} ): Promise<any> {
		let constraints = { args: `"rmid":"${id}"` };
		
		let url = `/aw-server/rest/auditentry/?`;
		url += `&page=${page}`;
		url += `&size=${paging.elementsPerPage}`;
		url += `&sort=${paging.sorting.sort}`;
		url += `&constraints=${encodeURIComponent(JSON.stringify(constraints))}`;

		try {
			const response = await firstValueFrom(this.http.get<any>(url, {}));

			if (response?.content) {
				let logs = response.content;
				logs.forEach((log: any) => {
					this.formatLogEvent(log);
				});
				return response;
			} else {
				return Promise.reject(false);
			}
		} catch (error) {
			return Promise.reject(false);
		}
	}

	private formatLogEvent(log: any) {
		if (!log) return;
		let d = new Date(log.auditDate);
		log.auditDateStr = d.toLocaleDateString('en-US') + ' ' + d.toLocaleTimeString('en-US');
		log.details = []; 
		if (log.args) {
			let argsObj = JSON.parse(log.args);
			log.productTitle = argsObj.title || "";
			log.folderTitle = argsObj.rm_folder_id || "";
			log.details = this.formatLogDetails(log.operation, argsObj);
		}
	}																						

	private formatLogDetails(op: string, argsObj: any= {}){
		var details = []; 
		switch (op) {
			case "addNewRecord": 
			case "removeRecord": 
				details.push("Title: " + argsObj.title);
				details.push("Folder: " + argsObj.rm_folder_id);
				break;     
			case "updateRecord":
			case "updateMetadata": 
				details.push("Update Type: " + argsObj.updateType);
				break;
			case "revertProduct":
				details.push("Version: " + argsObj.version);
				break;
			case "moveProduct":
				details.push("Previous Library: " + argsObj.beforeLibrary);
				details.push("New Library: " + argsObj.afterLibrary);
				break;					 
			case "completeRecord":
				break;   
			case "refileRecord": 
				details.push("Previous Folder: " + argsObj.previousFolderName);
				details.push("New Folder: " + argsObj.newFolderName);
				break;			   
			case "retentionPeriodExpired":
				details.push("Status: " + argsObj.dispositionStatus);
				details.push("Action: " + argsObj.retentionAction);
				details.push("Result: " + argsObj.dispositionResult);
				details.push("Retention Period: " + argsObj.retentionPeriod);
				break;					
			case "dispositionReviewed":
				details.push("Reviewer: " + argsObj.reviewer);
				details.push("Result: " + argsObj.reviewResult);
				if (argsObj.comments) {
					details.push("Comments: " + argsObj.comments);
				}
				break;					
			case "addRecordHold": 
			case "removeRecordHold":  
				details.push("Hold: " + argsObj.hold);
		    	break;
		  default:
		    // no-op
		}
		return details;		
	} 

	formatLogsAsCSV(logs: any) {
		var quotify = function(input: any) {
			return '"'+input+'"';
		}
		
		var content = 'Date,Event,Title,Folder,User,Details\n';
		
		logs.forEach((log: any) => {
			var data = [];
			data.push(
				quotify(log.auditDateStr),
				quotify(log.action),
				quotify(log.productTitle),
				quotify(log.folderTitle),
				quotify(log.user),
				quotify(log.details)
			);
			content += data.join(',') + "\n"; 
		});
		return content;		
	}
}
